/* eslint-disable max-len, react/jsx-indent, react/no-danger */
import React from 'react';

import UPSCEvaluatorImage from '../../assets/images/informatics/NewIcons/UPSCEvaluator.jpg';
import UPSCMentorshipImage from '../../assets/images/informatics/NewIcons/UPSCMentorship.jpg';
import EditorsImage from '../../assets/images/informatics/NewIcons/Editors.jpg';
import UPSCContentHindiImage from '../../assets/images/informatics/NewIcons/UpscContentHindi.jpg';
import GraphicsImage from '../../assets/images/informatics/NewIcons/GRAPHICS.jpg';
import UPSCContentEnglishImage from '../../assets/images/informatics/NewIcons/UPSCContentWritersEnglish.jpg';
import UPSCFacultyEnglishImage from '../../assets/images/informatics/NewIcons/UPSCFacultyEnglish.jpg';
import UPSCFacultyHindiImage from '../../assets/images/informatics/NewIcons/UPSCFacultyHindi.jpg';
import UPSCFacultyHinglishImage from '../../assets/images/informatics/NewIcons/UPSCFacultyHinglish.jpg';
import ExamCounsellors from '../../assets/images/informatics/NewIcons/ExamCounsellor.jpg';

import styles from '../../styles/policy.module.scss';

const careerData = [
  {
    formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLSfd2Al0gi8Kyv_9uZnRKBiSXvDvi_FK3TWZNKtVCxUNTJBkBw/viewform',
    imgSrc: UPSCEvaluatorImage?.src,
    title: 'UPSC Evaluators',
  },
  {
    formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLSfd2Al0gi8Kyv_9uZnRKBiSXvDvi_FK3TWZNKtVCxUNTJBkBw/viewform',
    imgSrc: UPSCMentorshipImage?.src,
    title: 'UPSC Mentorship',
  },
  {
    formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLSfd2Al0gi8Kyv_9uZnRKBiSXvDvi_FK3TWZNKtVCxUNTJBkBw/viewform',
    imgSrc: EditorsImage?.src,
    title: 'Editors and Scriptwriters',
  },
  {
    formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLSfd2Al0gi8Kyv_9uZnRKBiSXvDvi_FK3TWZNKtVCxUNTJBkBw/viewform',
    imgSrc: UPSCContentHindiImage?.src,
    title: 'UPSC Content Writers Hindi',
  },
  {
    formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLSfd2Al0gi8Kyv_9uZnRKBiSXvDvi_FK3TWZNKtVCxUNTJBkBw/viewform',
    imgSrc: GraphicsImage?.src,
    title: 'GRAPHICS',
  },
  {
    formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLSfd2Al0gi8Kyv_9uZnRKBiSXvDvi_FK3TWZNKtVCxUNTJBkBw/viewform',
    imgSrc: UPSCContentEnglishImage?.src,
    title: 'UPSC Content Writers English',
  },
  {
    formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLSfd2Al0gi8Kyv_9uZnRKBiSXvDvi_FK3TWZNKtVCxUNTJBkBw/viewform',
    imgSrc: UPSCFacultyEnglishImage?.src,
    title: 'UPSC Faculty English',
  },
  {
    formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLSfd2Al0gi8Kyv_9uZnRKBiSXvDvi_FK3TWZNKtVCxUNTJBkBw/viewform',
    imgSrc: UPSCFacultyHindiImage?.src,
    title: 'UPSC Faculty Hindi',
  },
  {
    formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLSfd2Al0gi8Kyv_9uZnRKBiSXvDvi_FK3TWZNKtVCxUNTJBkBw/viewform',
    imgSrc: UPSCFacultyHinglishImage?.src,
    title: 'UPSC Faculty Hinglish',
  },
  {
    formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLSfd2Al0gi8Kyv_9uZnRKBiSXvDvi_FK3TWZNKtVCxUNTJBkBw/viewform',
    imgSrc: ExamCounsellors?.src,
    title: 'UPSC Exam Counsellors',
  },
];

function EachCareer({ career }) {
  return (
    <div className={styles.job_post_wrapper}>
      <div className={styles.job_post}>
        <a
          target="_blank"
          className={styles.job_post_link}
          href={career?.formSrc}
          rel="noreferrer"
        >
          <div className={styles.job_post_banner_wrapper}>
            <img className={styles.job_post_banner} src={career?.imgSrc} />
          </div>

          <h3 className={styles.job_post_title}>{career?.title}</h3>
        </a>

        <div className={styles.job_post_actions}>
          <a
            className={`${styles.btn} ${styles.btn_orange} ${styles.btn_lg}`}
            target="_blank"
            href={career?.formSrc}
            rel="noreferrer"
          >
            READ MORE
          </a>
        </div>
      </div>
    </div>
  );
}

function Career() {
  return (
    <div className={styles.container}>
      <div className={styles.careerWrapper}>
        <div className={styles.heading_main}>
          Career with Us
        </div>
        <div className={styles.midContainer_career}>
          {careerData?.map((elem) => (
            <EachCareer key={elem?.title} career={elem} />
          ))}
        </div>

      </div>

    </div>
  );
}

export default Career;
